<div
    class="modal fade show"
    [ngClass]="{'expanded': isExpanded}"
    id="item-advance-search-modal"
    tabindex="-1"
    aria-labelledby="item-advance-search-modalLabel"
    aria-hidden="true"
    [ngStyle]="{'display': 'block'}"
>
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <div class="d-flex w-100">
                    <div class="me-2 id">
                        <h4 class="modal-title mb-0 item-id">Items</h4>
                    </div>
                    <div class="btns-header ms-auto">
                        <button
                            class="header-icon close p-0 m-0"
                            (click)="close()"
                            aria-label="Close"
                        >
                            <i
                                class="fas fa-times"
                                title="Close Popup"
                            ></i>
                        </button>
                        <button
                            class="close header-icon expand-modal p-0 m-0"
                            (click)="isExpanded = !isExpanded"
                        >
                            <i
                                class="fas ms-2 me-2"
                                [ngClass]="{'fa-expand-alt': !isExpanded, 'fa-compress-alt': isExpanded}"
                                [title]="isExpanded ? 'Exit Full Screen' : 'Enter Full Screen'"
                            ></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-body pt-3">
                <div class="row">
                    <div class="col">
                        @if (gridConfig) {
                        <div [style.height.px]="gridHeight">
                            <inavista-grid class="so-popup-grid"
                                [config]="gridConfig"
                                [actionIcons]="actionIcons"
                                (rowSelected)="rowSelected($event)"
                                (hyperlinkClick)="onHyperlinkClick($event)"
                                (actionIconClick)="onActionIconClick($event)" />
                        </div>
                        }
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-danger close-modal" (click)="close()">Close</button>
            </div>
        </div>
    </div>
</div>
